import JogoRifa from "./jogoRifa";
import Lista from "./list";
import NumberGrid from "./numberGrid";
import Cart from "./cart";
import SearchNumber from "./search";
import Ticket from "./ticket";
import Bets from "./bets";

export {
    JogoRifa,
    Lista,
    NumberGrid,
    Cart,
    SearchNumber,
    Ticket,
    Bets
}


// WEBPACK FOOTER //
// ./src/rifa/components/index.js